import React from 'react'
import EditWithAIGhostSuggestions from './EditWithAIGhostSuggestions'
import HorizontalScroller from '@/components/HorizontalScroller'
import SuggestedButton from './SuggestedButton'
import SuggestedButtonImageInCircle from './SuggestedButtonImageInCircle'
import { renderSuggestionPopover } from '@/components/AIPopovers'
import type { SuggestionButton } from './suggestedButtonSets'

export type EditWithAISuggestionsBarProps = {
  isVisible: boolean
  isGhost?: boolean
  width: number
  arrowsPlacement?: 'inside' | 'outside'
  buttons: SuggestionButton[]
  onActionSelect: (action: string) => void
}

function EditWithAISuggestionsBar({
  isVisible,
  isGhost = false,
  width,
  arrowsPlacement,
  buttons,
  onActionSelect,
}: EditWithAISuggestionsBarProps) {
  if (isGhost) {
    return <EditWithAIGhostSuggestions isVisible={isVisible} width={width} arrowsPlacement={arrowsPlacement} />
  }

  if (!isVisible || buttons.length === 0) return null

  return (
    <HorizontalScroller width={width} showScrollArrows arrowPlacement={arrowsPlacement}>
      {buttons.map((action) =>
        action.buttonStyle === 'imageInCircle' ? (
          <SuggestedButtonImageInCircle
            key={action.value ? `${action.title}:${action.value}` : action.title}
            src={action.imageSrc}
            text={action.title}
            onClick={action.onClick}
            showArrow={action.popover ? 'up' : 'none'}
            popoverContent={
              action.popover
                ? (buttonRef, closePopover) =>
                    renderSuggestionPopover(action.popover!, buttonRef, closePopover, onActionSelect)
                : undefined
            }
          />
        ) : (
          <SuggestedButton
            key={action.value ? `${action.title}:${action.value}` : action.title}
            icon={action.icon}
            text={action.title}
            onClick={() => {
              if (action.onClick) {
                action.onClick()
              } else if (!action.popover) {
                onActionSelect(action.value || action.title)
              }
            }}
            showArrow={action.popover ? 'up' : 'none'}
            popoverContent={
              action.popover
                ? (buttonRef, closePopover) =>
                    renderSuggestionPopover(action.popover!, buttonRef, closePopover, onActionSelect)
                : undefined
            }
          />
        )
      )}
    </HorizontalScroller>
  )
}

export default EditWithAISuggestionsBar
